exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".short-ship-quantity input{pointer-events:none}", ""]);

// exports
